'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../../common/components/button');

var _button2 = _interopRequireDefault(_button);

var _signupOrLoginButton = require('./signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO CTA Buttons',

    signupOrLoginButtonProps: function signupOrLoginButtonProps() {
        return {
            classNames: 'm-marketing-page--button',
            styleAttributes: 'width: 274px',
            buttonText: this.props.signupButtonText,
            buttonUrl: this.props.signupButtonUrl
        };
    },

    secondButtonProps: function secondButtonProps() {
        return {
            buttonText: this.props.secondButtonText,
            buttonLink: this.props.secondButtonUrl,
            buttonColor: 'plume',
            buttonTextColor: 'goldenrod',
            buttonTextUppercase: false,
            buttonBorderColor: 'goldenrod',
            buttonHoverColor: 'goldenrod',
            buttonHoverTextColor: 'white'
        };
    },

    render: function render() {
        var props = this.props;
        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'columns small-12 small-centered small-text-center'
        }, void 0, _jsx('div', {
            className: 'l-padding-t-40 l-padding-b-15'
        }, void 0, _jsx('h2', {
            className: 'm-marketing-page--get-started'
        }, void 0, props.title), _jsx('h4', {
            className: 'm-marketing-page--subheader',
            style: { maxWidth: 1100 }
        }, void 0, props.subtitle))), _jsx('div', {
            className: 'row l-padding-b-30'
        }, void 0, _jsx('div', {
            className: 'small-12 columns text-center'
        }, void 0, _jsx('div', {
            className: 'm-marketing-page--button-inline'
        }, void 0, _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, this.signupOrLoginButtonProps(), props))), _jsx('div', {
            className: 'm-marketing-page--button-inline',
            id: 'set-up-a-demo-link'
        }, void 0, _react2['default'].createElement(_button2['default'], _extends({}, this.secondButtonProps(), props))))));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/cta-buttons.jsx
 ** module id = 815
 ** module chunks = 0
 **/